var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrDelete(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50012 15C2.04179 15 1.64943 14.8368 1.32304 14.5104C0.99665 14.184 0.833455 13.7917 0.833455 13.3333V2.5H0.00012207V0.833333H4.16679V0H9.16679V0.833333H13.3335V2.5H12.5001V13.3333C12.5001 13.7917 12.3369 14.184 12.0105 14.5104C11.6841 14.8368 11.2918 15 10.8335 15H2.50012ZM10.8335 2.5H2.50012V13.3333H10.8335V2.5ZM4.16679 11.6667H5.83346V4.16667H4.16679V11.6667ZM7.50012 11.6667H9.16679V4.16667H7.50012V11.6667ZM2.50012 2.5V13.3333V2.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrDelete);
export default __webpack_public_path__ + "static/media/cr-delete.83a6e93b3ebf9cfb9acc672aa1f4d90a.svg";
export { ForwardRef as ReactComponent };